module.exports = __webpack_public_path__ + "f323edeea9058ded98148eefffb1794a.woff";